import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Normalize a LinkedIn URL to an absolute https:// URL.
 * Handles bare (linkedin.com/in/x), www-, and already-absolute forms.
 * Returns null/undefined as-is so callers can guard on presence.
 */
export function normalizeLinkedinUrl(url: string | null | undefined): string | null | undefined {
  if (!url) return url;
  if (url.startsWith('http')) return url;
  return `https://${url}`;
}
